import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  propertyId: null,
  roomBookings: null,
};

export const roomSlice = createSlice({
  name: "room",
  initialState,
  reducers: {
    setPropertyId: (state, action) => {
      state.propertyId = action.payload;
    },
    clearPropertyId: (state) => {
      state.propertyId = null;
      state.roomBookings = null;
    },
    setRoomBookings: (state, action) => {
      state.roomBookings = action.payload;
    },
  },
});

export const { setPropertyId, clearPropertyId, setRoomBookings } = roomSlice.actions;

export default roomSlice.reducer; 